<template>
  <div class="main" @click="go_info">
    <div class="card">
      <p>云南省卫生健康委员会</p>
      <div class="name">
        <b>{{ info.name }}</b>
        <span>{{ info.id_card.substr(0, 4) }}**********{{ info.id_card.substr(14) }}</span>
      </div>
      <div class="code">
        <!-- <qrcode :url="info.health_card" :iconurl="icon" :wid="70" :hei="70" :imgwid="23" :imghei="23"></qrcode>-->
        <img :src="info.src" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import qrcode from 'vue_qrcodes'
Vue.use(qrcode)
export default {
  props: ['info'],
  data() {
    return {
      list: 1
    }
  },
  methods: {
    go_info() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base.less';
.main {
  width: 100%;
  height: 100%;
  .card {
    width: 85%;
    margin-left: 7.5%;
    height: 4.5rem;
    background: url('/static/img/card/card.png') no-repeat;
    background-size: contain;
    position: relative;
    p {
      position: absolute;
      top: 0.5rem;
      left: 0.5rem;
    }
    .name {
      position: absolute;
      display: flex;
      flex-direction: column;
      bottom: 1rem;
      left: 0.5rem;
      b {
        font-size: 0.4rem;
        margin-bottom: 0.1rem;
      }
    }
    .code {
      position: absolute;
      right: 0.5rem;
      bottom: 1rem;
      display: block;
      width: 2rem;
      height: 2rem;
      img {
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
